module.exports = __webpack_public_path__ + "static/media/shell32_136.8683e84b.ico";